import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=6b5f69c5&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=6b5f69c5&prod&scoped=true&lang=scss&"
import style1 from "./CompanyInfo.vue?vue&type=style&index=1&id=6b5f69c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f69c5",
  null
  
)

export default component.exports